import { useState, useEffect } from 'react';
import styled from 'styled-components';

const ReticleContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10;
`;

const ReticleElement = styled.div`
	position: absolute;
	width: 20px;
	height: 20px;
	border: 2px solid #ff0000;
	border-radius: 50%;
	transform: translate(-50%, -50%);
	display: ${(props) => (props.$visible ? 'block' : 'none')};
	pointer-events: none;

	&::after {
		content: '${(props) => props.$coordinates}';
		position: absolute;
		top: 25px;
		left: 50%;
		transform: translateX(-50%);
		background: rgba(0, 0, 0, 0.8);
		color: white;
		padding: 4px 8px;
		border-radius: 4px;
		font-size: 12px;
		white-space: nowrap;
	}
`;

const Reticle = ({ active }) => {
	const [position, setPosition] = useState({ x: 0, y: 0 });
	const [visible, setVisible] = useState(false);

	const handleMouseMove = (e) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const x = ((e.clientX - rect.left) / rect.width) * 100;
		const y = ((e.clientY - rect.top) / rect.height) * 100;
		setPosition({ x, y });
	};

	useEffect(() => {
		const handleKeyPress = (e) => {
			if (e.key === 'r') {
				setVisible((prev) => !prev);
			}
		};

		document.addEventListener('keypress', handleKeyPress);

		return () => {
			document.removeEventListener('keypress', handleKeyPress);
		};
	}, []);

	if (!active) return null;

	return (
		<ReticleContainer onMouseMove={handleMouseMove}>
			<ReticleElement
				$visible={visible}
				$coordinates={`${position.x.toFixed(1)}%, ${position.y.toFixed(1)}%`}
				style={{
					left: `${position.x}%`,
					top: `${position.y}%`,
				}}
			/>
		</ReticleContainer>
	);
};

export default Reticle;
